// src/components/gauges/SmartGauge.jsx
import React from "react";
import Widget from "../common/Widget";
import GaugeBase from "./GaugeBase";
import { Box, CircularProgress } from "@mui/material";

// --- Helpers ---
function parseNum(value) {
  if (value == null || value === "") return null;

  // Acepta "12,3" o "12.3"
  const n = Number(String(value).trim().replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

function getRangeHit(v, ranges) {
  return (ranges || []).find(
    (r) => (r.min == null || v >= r.min) && (r.max == null || v <= r.max)
  );
}

// Acepta color como:
// - "green" | "yellow" | "red" | "grey"
// - "#rrggbb"
function resolveColor(color) {
  const colorMap = {
    green: "#4caf50",
    yellow: "#ff9800",
    red: "#d50000",
    grey: "#9e9e9e",
    gray: "#9e9e9e",
  };

  if (!color) return colorMap.grey;

  // HEX
  if (typeof color === "string" && color.trim().startsWith("#")) return color.trim();

  // nombre
  const key = String(color).trim().toLowerCase();
  return colorMap[key] || colorMap.grey;
}

function resolveStatusLabel(hit, numericValue) {
  if (numericValue == null) return "Sin dato";
  if (hit?.label) return hit.label;

  const statusLabelMap = {
    green: "OK",
    yellow: "Advertencia",
    red: "Alarma",
    grey: "Fuera de rango",
    gray: "Fuera de rango",
  };

  const c = String(hit?.color || "").trim().toLowerCase();
  return statusLabelMap[c] || "—";
}

export default function SmartGauge({
  value,
  title,
  ranges,
  unit = "°C",
  loading = false,
}) {
  // ✅ Loading: MISMO look viejo (Widget) pero centrado
  if (loading) {
    return (
      <Widget title={title}>
        <Box
          sx={{
            height: 170,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            py: 1,
          }}
        >
          <CircularProgress size={26} />
        </Box>
      </Widget>
    );
  }

  const numericValue = parseNum(value);

  // range match (soporta min/max null)
  const hit =
    numericValue != null && !Number.isNaN(numericValue)
      ? getRangeHit(numericValue, ranges)
      : null;

  const gaugeColor = resolveColor(hit?.color);
  const statusLabel = resolveStatusLabel(hit, numericValue);

  return (
    <Widget title={title}>
      <GaugeBase value={numericValue} unit={unit} color={gaugeColor} statusLabel={statusLabel} />
    </Widget>
  );
}
